<template>
  <teleport to="body">
    <div class="toast-container position-fixed bottom-0 end-0 p-3">
      <!--  Error Toast-->
      <div id="toastError" aria-atomic="true" aria-live="assertive" class="toast bg-danger text-white hide"
           data-delay="10000" role="alert"
           v-on="{'hidden.bs.toast': onHidden}"
      >
        <div class="toast-header bg-danger text-white">
          <strong class="me-auto">Fehler</strong>
          <button aria-label="Close" class="btn-close" data-bs-dismiss="toast" type="button"></button>
        </div>
        <div class="toast-body">
          {{ modelValue }}
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import {onMounted, ref, watch} from "vue";
import {Toast} from 'bootstrap';

// prop for v-model
const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  }
});

// emit v-model update
const emit = defineEmits(['update:modelValue']);

// global variable toast
let toast;

// on toast hide: emit new v-model empty string
const onHidden = () => {
  emit('update:modelValue', '');
}

// watch v-model change
watch(() => props.modelValue, newValue => {
  if (newValue !== '') {
    toast.show();
  }
});

// get toast from dom
onMounted(() => {
  toast = new Toast(document.querySelector('#toastError'));
});

</script>

<style scoped>

</style>